export interface CountryFilterType {
  selectedCountries: server.dto.Country[]
}

export const getSortedCountryLabels = (filter: CountryFilterType): string[] => {
  return filter.selectedCountries.map(c => c.name).sort((a, b) => a.localeCompare(b));
};


export const initialCountriesFilter: CountryFilterType = {
  selectedCountries: [],
};